// extracted by mini-css-extract-plugin
export default {"container":"imageCarousel_container__jiXC0","imageText":"imageCarousel_imageText__fCMfj"};